import { type BuyerLoadSampleWithBreakdown, SampleType, type SiteMaterialSampleWithBreakdown } from 'api';
import { formatDate } from 'date';
import { Card, formatNumber, Stack } from 'ui';
import { Notes, Person, Scale } from 'ui/icons';

import { AIBadge } from '../AIBadge/AIBadge';

const SampleTitle = ({ sample }: { sample: SiteMaterialSampleWithBreakdown | BuyerLoadSampleWithBreakdown }) => (
  <Stack direction="row" gap={1}>
    {formatDate(sample.date)}
    {sample.type === SampleType.AG && <AIBadge />}
  </Stack>
);

export const SampleCard = ({
  sample,
  isSelected,
}: {
  sample: SiteMaterialSampleWithBreakdown | BuyerLoadSampleWithBreakdown;
  isSelected?: boolean;
}) => {
  const items = [{ icon: Notes, label: sample.description }];

  if (sample.total_weight) {
    items.push({
      icon: Scale,
      label: formatNumber(sample.total_weight, { style: 'kilogram' }),
    });
  }

  if (sample.user) {
    items.push({ icon: Person, label: sample.user.full_name });
  }
  return (
    <Card title={<SampleTitle sample={sample} />} isSelected={isSelected}>
      <Card.UnorderedList items={items} />
    </Card>
  );
};
